<template>
    <v-container color="primary">
        <v-row v-if="isAutomatic">
            <v-col>
                <MaterialfyBotAutoSave v-if="mode" :mode="mode" :data="suscripcion" />
                <p v-else-if="loading">Cargando...</p>
                <p v-else-if="error">Error al cargar los datos.</p>
            </v-col>
        </v-row>
        <v-row v-if="!isAutomatic">
            <v-col>
                <MaterialfyBotStandardSave v-if="mode" :mode="mode" :data="suscripcion" />
                <p v-else-if="loading">Cargando...</p>
                <p v-else-if="error">Error al cargar los datos.</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserService from '@/services/user.service'

export default {
    name: "BotSaveView",
    data: () => ({
        title: 'Bot Save',
        idSuscripcion: '',
        isPremium: false,
        suscripcion: null,
        mode: null,
        loading: true,
        error: false,
        isAutomatic: false
    }),
    async created() {
        try {
            this.idSuscripcion = this.$route.query.idSuscripcion
            if (this.$route.query.tipo === 'auto') {
                this.isAutomatic = true
            }
            UserService.getSuscripcion(this.idSuscripcion).then(
                response => {
                    this.suscripcion = response.data
                    // console.log(this.suscripcion)
                    // console.log(this.suscripcion.tipoSuscripcion)
                    // 18012025 Se añade nueva mejora para añadir interes compuesto INICIO
                    if (this.suscripcion.tipoSuscripcion.nombre.includes('Premium')) {
                        // console.log('ES PREMIUM')
                        this.isPremium = true
                    }
                    // 18012025 Se añade nueva mejora para añadir interes compuesto FIN
                    if (this.suscripcion.bot === null) {
                        this.mode = 'create'
                        this.title = 'CREA TU BOT'
                        // this.isBot = false
                    } else {
                        this.mode = 'edit'
                        this.title = 'ACTUALIZA TU BOT'
                        // this.isBot = true
                        // this.chargeBot(this.suscripcion.bot.id)
                    }
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()

                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        } catch (err) {
            this.error = true;
            console.error('Error al cargar los datos:', err);
        } finally {
            this.loading = false;
        }
    },
    mounted() { },

    methods: { },
};
</script>

<style></style>
